// @flow
import React from 'react'
import styled, { css } from 'styled-components'
// $FlowFixMe
import ReactTooltip from 'react-tooltip'
import TooltipData from '../../ducks/Tooltips/TooltipData'

import Modal from '../../containers/SecureRoom/components/MobileHeader/Modal'
import Close from '../../assets/icons/e-remove.svg'
import { media } from '../../theme/style-utils'

const StyledReactTooltip = styled(ReactTooltip)`
  opacity: 1 !important;
  max-width: 20rem;
`

type Props = {
  id?: string,
  type: string,
  variation?: string
}

type State = {
  showModal: boolean
}

export const VARIATIONS = {
  BLACK: 'black',
  GREEN: 'green'
}

const Info = styled.span`
  background-color: #c1e2bc;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: #fff;
  width: 16px;
  height: 16px;
  cursor: pointer;
  margin-left: 5px;

  ${(props: Props) =>
    props.variation === 'black' &&
    css`
      background-color: #000;
    `};
`

const TooltipContainer = styled.span`
  display: none;
  ${media.desktop`
    display: inline-block;
  `}
`

const ModalContainer = styled.span`
  ${media.desktop`
    display: none;
  `}
`

const StyledModal = styled(Modal)`
  ${media.desktop`
    display: none;
  `}
`

const ModalInfo = styled.div`
  background-color: #fff;
  width: calc(100% - 72px);
  max-height: calc(100% - 72px);
  border-radius: 6px;
  -webkit-box-shadow: 0 4px 40px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 4px 40px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 4px 40px 0 rgba(0, 0, 0, 0.15);
`

const ModalContent = styled.div`
  position: relative;
  padding: 30px 0;
  margin: 30px;
`

const ModalTitle = styled.h2`
  margin-top: 0;
  font-family: 'RelativeMedium';
  font-size: 18px;
  font-weight: 500;
`

const CloseButton = styled.button`
  background-color: transparent;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
`

class Tooltip extends React.PureComponent<Props, State> {
  state = {
    showModal: false
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleCloseModal)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleCloseModal)
  }

  openModal = () => {
    this.setState({ showModal: true })
  }
  handleCloseModal = () => {
    this.setState({ showModal: false })
  }

  render() {
    const { type, variation } = this.props

    return (
      <React.Fragment>
        <TooltipContainer>
          <span data-tip={type} onClick={this.openModal} data-event="click">
            <Info variation={variation}>i</Info>
          </span>
          <StyledReactTooltip
            getContent={tooltipType => (
              <div>
                <h3>{tooltipType && TooltipData[tooltipType].title}</h3>
                <p>{tooltipType && TooltipData[tooltipType].content}</p>
              </div>
            )}
            place="top"
            effect="solid"
            globalEventOff="click"
          />
        </TooltipContainer>

        <ModalContainer>
          <span onClick={this.openModal}>
            <Info variation={variation}>i</Info>
          </span>
          {this.state.showModal && (
            <StyledModal open={this.state.showModal} toClose={this.handleCloseModal}>
              <ModalInfo>
                <ModalContent>
                  <ModalTitle>{TooltipData[type].title}</ModalTitle>
                  {TooltipData[type].content}
                  <CloseButton onClick={this.handleCloseModal}>
                    <img id="close-modal-btn" alt="close modal" src={Close} />
                  </CloseButton>
                </ModalContent>
              </ModalInfo>
            </StyledModal>
          )}
        </ModalContainer>
      </React.Fragment>
    )
  }
}

export default Tooltip



// WEBPACK FOOTER //
// ./src/components/Tooltip/Tooltip.js